import { TagularAdapter, type TagularAdapterOptions } from './TagularAdapter';

export function createTagularAdapter(
  options?: TagularAdapterOptions,
): TagularAdapter {
  return new TagularAdapter(options);
}

export type { TagularAdapterOptions } from './TagularAdapter';
